import { cookie } from 'src/shared/cookie/reducers';

/**
 * Check if Hint cookie is set
 */
export const isHintCookieSet = (state) => {
  if (typeof window === 'undefined') return undefined;

  const cookies = cookie(state); // parsed cookies object
  const flags = window.XHS?.config?.flags;
  const constants = window.XHS?.config?.constants;

  if (!flags || !constants) return undefined;

  if (flags.enableHintCookieAuth) {
    return !!cookies[constants.hintCookieKey];
  } else {
    return cookies[constants.isAuthCookieKey] === '1';
  }
};

/**
 * Get AuthGuid from account-context cookie.
 * Example cookie value: xfin_s_ctx=33974295 (or xfin_ctx in prod/staging)
 * @returns AuthGuid string if found, undefined otherwise
 */

export const getAuthGuidFromAccountContextCookie = (state) => {
  if (typeof window === 'undefined') return undefined;

  const cookies = cookie(state);
  const key = window.XHS?.config?.constants?.accountContextCookieKey;

  if (!key) return undefined;

  return cookies[key]?.trim() || undefined;
};

if (typeof window !== 'undefined') {
  window.XHS = window.XHS || {};
  window.XHS.auth = window.XHS.auth || {};

  window.XHS.auth.isHintCookieSet = isHintCookieSet;
}
